module.exports = __webpack_public_path__ + "static/media/takethestage3.d13f597f.jpg";